import { render } from "./indexItem.vue?vue&type=template&id=599b4346"
import script from "./indexItem.vue?vue&type=script&setup=true&lang=js"
export * from "./indexItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductUpgrade/indexItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "599b4346"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('599b4346', __exports__)) {
    api.reload('599b4346', __exports__)
  }
  
  module.hot.accept("./indexItem.vue?vue&type=template&id=599b4346", () => {
    api.rerender('599b4346', render)
  })

}


export default __exports__